(function() {

    window.__extends = window.__extends || function (subclass, baseclass) {
        for (var propertyName in baseclass) if (baseclass.hasOwnProperty(propertyName)) subclass[propertyName] = baseclass[propertyName];
        function __() { this.constructor = subclass; }
        __.prototype = baseclass.prototype;
        subclass.prototype = new __();
    };

    
})();
define("fileplanutil", function(){});

